<nb-select
	placeholder="{{ 'CANDIDATES_PAGE.STATISTIC.SELECT_INTERVIEW' | translate }}"
	class="select"
	(selectedChange)="onInterviewSelected($event)"
	*ngIf="candidates.length > 0"
>
	<nb-option-group
		*ngFor="let candidate of candidates"
		title="{{ candidate.user.name }}"
	>
		<nb-option
			*ngFor="let interview of candidate.interview"
			[value]="interview"
		>
			{{ interview.title }}
		</nb-option>
	</nb-option-group>
</nb-select>
<div *ngIf="rating?.length === 0" class="no-data">
	<nb-icon icon="info-outline" class="no-data-icon"></nb-icon>
	<span class="no-data-text">{{
		'CANDIDATES_PAGE.STATISTIC.NO_DATA' | translate
	}}</span>
	<span class="no-data-text" *ngIf="candidates.length > 0">
		{{ 'CANDIDATES_PAGE.STATISTIC.SELECT_INTERVIEW' | translate }}
	</span>
</div>
<chart
	*ngIf="rating?.length > 0"
	style="height: 400px; width: 100%"
	type="bar"
	[data]="data"
	[options]="options"
></chart>
